import { render } from "./AcceptApplicantPersonalInfo.vue?vue&type=template&id=d20d7f8a"
import script from "./AcceptApplicantPersonalInfo.vue?vue&type=script&lang=js"
export * from "./AcceptApplicantPersonalInfo.vue?vue&type=script&lang=js"

import exportComponent from "/Users/macbookpro/Herd/hris-laravel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__